import { defineComponent as _defineComponent } from 'vue'
import BasketLineItemImage from '@/ui/views/checkout/BasketLineItemImage.vue';
import UpdateLineItemWebRequest = Vertica.LouisPoulsen.Application.Commerce.Requests.UpdateLineItemWebRequest;
import UpdateLineReferenceWebRequest = Vertica.LouisPoulsen.Application.Commerce.Requests.UpdateLineReferenceWebRequest;
import RemoveFromBasketWebRequest = Vertica.LouisPoulsen.Application.Commerce.Requests.RemoveFromBasketWebRequest;
import { BasketType } from '@/enums';
import { store } from '@/store';
import { computed, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketLineItemB2B',
  props: {
    lineItem: null,
    salesInfo: null
  },
  setup(__props: any) {

const props = __props as {
    lineItem: LineItemViewObject,
    salesInfo?: SalesInfoViewObject
}



const showStock = computed<boolean>(() => store.getters['app/showStock']);
function updateLineItem(request: UpdateLineItemWebRequest) {
    store.dispatch('basket/updateLineItem', request);
}
function updateLineReference(request: UpdateLineReferenceWebRequest) {
    store.dispatch('basket/updateLineReference', request);
}
function removeFromBasket(request: RemoveFromBasketWebRequest) {
    store.dispatch('basket/removeFromBasket', request);
}

const stock = ref<string>('');
const delivery = ref<string>('-');
const reference = ref<string>(props.lineItem.reference);
const quantity = ref<string>(props.lineItem.quantity.toString());

watch(() => props.salesInfo, onSalesInfoChanged);
function onSalesInfoChanged() {
    if (!props.salesInfo) { return; }

    stock.value = props.salesInfo.stock;
    delivery.value = props.salesInfo.delivery;
}

function updateReference(input: string) {
    reference.value = input;
}

function updateQuantity(input: string) {
    quantity.value = input;
}

function onReferenceChange() {
    const request : UpdateLineReferenceWebRequest = {
        lineItemId: props.lineItem.lineItemId,
        lineReference: reference.value,
        basketType: BasketType.B2B as any
    };
    updateLineReference(request);
}

function onQuantityChange() {
    if (!quantity.value) { return; };

    const quantityValue = parseInt(quantity.value, 10);

    if (Number.isNaN(quantityValue)) {
        console.error('Quantity is not a number');
        return;
    }

    if (props.lineItem.quantity === quantityValue) { return; }

    updateLineItem({ id: props.lineItem.lineItemId, quantity: quantityValue, basketType: BasketType.B2B as any });
}

function onRemoveFromBasket() {
    removeFromBasket({ id: props.lineItem.lineItemId, basketType: BasketType.B2B as any });
}

function getProductLine(lineItem: LineItemViewObject) {
    let output = '';

    output += lineItem.productName;

    if (lineItem.properties) {
        output += ', ' + lineItem.properties;
    }

    return output;
}

return { __sfc: true,props, showStock, updateLineItem, updateLineReference, removeFromBasket, stock, delivery, reference, quantity, onSalesInfoChanged, updateReference, updateQuantity, onReferenceChange, onQuantityChange, onRemoveFromBasket, getProductLine, BasketLineItemImage }
}

})